export const backdropStyles = {
  zIndex: 1500,
  backgroundColor: 'rgba(0, 0, 0, 0.9)',
  backdropFilter: 'blur(8px)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center'
}

// alignment: 'LEFT' | 'CENTER' | 'RIGHT'
export const getThumbnailStyles = (alignment = 'CENTER') => {
  let objectPositionValue = 'center center'
  if (alignment === 'LEFT') {
    objectPositionValue = 'left center'
  } else if (alignment === 'RIGHT') {
    objectPositionValue = 'right center'
  }

  return {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    objectPosition: objectPositionValue,
    borderRadius: '12px',
    cursor: 'pointer',
    transition: 'transform 0.3s ease',
    '&:hover': {
      transform: 'scale(1.02)'
    }
  }
}
